import destroys from '../util/elements/destroys'
import { GoogleMaps, LatLng } from '../lib/google-maps'

const key = 'AIzaSyB-xk76veLF3fKSOtbRi12v5pAWmp6LxBQ'
const Map = new GoogleMaps({
  key,
})

export default function widgetMap(Site, $) {
  Site.widget('map', {
    _create() {
      destroys(this)
    },
    options: {
      locations: [],
    },
    async _transitionIn() {
      const GoogleMap = await Map.getInstance()
      const mapOptions = Map.getDefaultMapOptions()
      const markerOptions = Map.getDefaultMarkerOptions()
      this.bounds = new GoogleMap.LatLngBounds()
      this.locations = this.options.locations.map((loc) => {
        return new LatLng(Number(loc.lat), Number(loc.lng))
      })

      const mapOpts = {
        ...mapOptions,
        center:
          this.locations.length === 1
            ? this.locations[0]
            : new LatLng(-33.865143, 151.2099), // default to canberra
        zoom: 15,
      }

      this.map = new GoogleMap.Map(this.element.get(0), mapOpts)

      this.markers = this.locations.map((point) => {
        const markerBase = {
          ...markerOptions,
          position: point,
          map: this.map,
          icon: {
            url: this.options.icon,
            scaledSize: new GoogleMap.Size(45, 45),
            origin: new GoogleMap.Point(0, 0),
            anchor: new GoogleMap.Point(18, 20),
          },
        }

        const marker = new GoogleMap.Marker(markerBase)

        // this.bounds.extend(marker)
        return marker
      })

      this.fitBounds()

      // Double check that it fits after 300 (Give time for layout)
      await wait(300)
      this.fitBounds()
    },
    fitBounds() {
      // Don't worry centering if we only have 1 location (because it will be in the center)
      if (this.locations.length === 1) return

      this.map.fitBounds(this.bounds)
      this.map.setZoom(this.map.zoom * 0.93)
    },
  })
}

function safelyParse(raw) {
  try {
    return JSON.parse(raw)
  } catch (e) {
    console.error(e)
  }
}

function wait(t) {
  return new Promise((resolve) => setTimeout(resolve, t))
}
